import { render } from "./CommentCell.vue?vue&type=template&id=ab3975b0&scoped=true&ts=true&lang=pug"
import script from "./CommentCell.vue?vue&type=script&lang=ts"
export * from "./CommentCell.vue?vue&type=script&lang=ts"

import "./CommentCell.vue?vue&type=style&index=0&id=ab3975b0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab3975b0"]])

export default __exports__